import { Trans } from "@lingui/macro";
import { BigNumber } from "ethers";
import { USD_DECIMALS } from "lib/legacy";
import "./StatsTooltip.css";
import { formatAmount } from "lib/numbers";

type Props = {
  title: string;
  total?: BigNumber;
  opValue?: BigNumber;
  opLegacyValue?: BigNumber;
  fantomValue?: BigNumber;
  fantomLegacyValue?: BigNumber;
  arbValue?: BigNumber;
  baseValue?: BigNumber;
  showDollar?: boolean;
  decimalsForConversion: number;
  symbol: string;
};

export default function StatsTooltip({
  title,
  total,
  opValue,
  opLegacyValue,
  fantomValue,
  fantomLegacyValue,
  arbValue,
  baseValue,
  showDollar = true,
  decimalsForConversion = USD_DECIMALS,
  symbol,
}: Props) {
  return (
    <>
      <p className="Tooltip-row">
        <span className="label">
          <div>{title} on Fantom:</div>
        </span>
        <span className="amount">
          {showDollar && "$"}
          {formatAmount(fantomValue, decimalsForConversion, 0, true)}
          {!showDollar && symbol && " " + symbol}
        </span>
      </p>
      <p className="Tooltip-row">
        <span className="label">
          <div>{title} on Fantom legacy:</div>
        </span>
        <span className="amount">
          {showDollar && "$"}
          {formatAmount(fantomLegacyValue, decimalsForConversion, 0, true)}
          {!showDollar && symbol && " " + symbol}
        </span>
      </p>
      
      <p className="Tooltip-row">
        <span className="label">
          <div>{title} on Optimism:</div>
        </span>
        <span className="amount">
          {showDollar && "$"}
          {formatAmount(opValue, decimalsForConversion, 0, true)}
          {!showDollar && symbol && " " + symbol}
        </span>
      </p>
      {opLegacyValue &&<p className="Tooltip-row">
        <span className="label">
          <div>{title} on Optimism legacy:</div>
        </span>
        <span className="amount">
          {showDollar && "$"}
          {formatAmount(opLegacyValue, decimalsForConversion, 0, true)}
          {!showDollar && symbol && " " + symbol}
        </span>
      </p> }
      <p className="Tooltip-row">
        <span className="label">
          <div>{title} on Arbitrum:</div>
        </span>
        <span className="amount">
          {showDollar && "$"}
          {formatAmount(arbValue, decimalsForConversion, 0, true)}
          {!showDollar && symbol && " " + symbol}
        </span>
      </p>
      <p className="Tooltip-row">
        <span className="label">
          <div>{title} on Base:</div>
        </span>
        <span className="amount">
          {showDollar && "$"}
          {formatAmount(baseValue, decimalsForConversion, 0, true)}
          {!showDollar && symbol && " " + symbol}
        </span>
      </p>
      <div className="Tooltip-divider" />
      <p className="Tooltip-row">
        <span className="label">
          <span>Total:</span>
        </span>
        <span className="amount">
          {showDollar && "$"}
          {formatAmount(total, decimalsForConversion, 0, true)}
          {!showDollar && symbol && " " + symbol}
        </span>
      </p>
    </>
  );
}
